import toast, { type ToastOptions } from "react-hot-toast";

/**
 * Centralized toast helper (#26).
 *
 * Errors persist until the user dismisses them (they multitask, so an
 * auto-dismissed error reads as "no response at all"). Info and success toasts
 * use a longer default timeout than the react-hot-toast 4s default and accept a
 * per-call `duration` override.
 *
 * These defaults mirror the global <Toaster> configuration in App.tsx, so
 * existing direct `toast.error(...)` calls already persist; this helper is the
 * preferred API for new notifications and for configurable info timeouts.
 */
const INFO_DURATION_MS = 6000;
const SUCCESS_DURATION_MS = 5000;

export const notify = {
  /** Persists until dismissed. */
  error: (message: string, options?: ToastOptions) =>
    toast.error(message, { duration: Infinity, ...options }),

  /** Auto-dismisses after a longer-than-default timeout. */
  success: (message: string, options?: ToastOptions) =>
    toast.success(message, { duration: SUCCESS_DURATION_MS, ...options }),

  /** Info toast; pass `{ duration }` to override the default timeout. */
  info: (message: string, options?: ToastOptions) =>
    toast(message, { duration: INFO_DURATION_MS, ...options }),

  dismiss: toast.dismiss,
};
